import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid2,
  Button,
  Link,
  Stack,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import AlertMessage from "../../components/common/AlertMessage";
import ForgotPasswordPageAPI from "../../utils/services/forgotPassword.api";
import "../../styles/LoginPage.css";
import Loaders from "../../components/common/Loaders";
import { SetPasswordSchema } from "../../utils/schema/completeProfileSchema";

function SetNewPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { resetPassword } = ForgotPasswordPageAPI;
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: SetPasswordSchema,
    onSubmit: async (values) => {
      if (values.password === values.confirmPassword) {
        setLoading(true);
        const response = await resetPassword({
          email: location.state.emailId,
          newPassword: values.password,
          confirmPassword: values.confirmPassword,
        });
        if (response.status === "success") {
          setOpen(true);
          setMessage("Password changed successfully");
          setSeverity("success");
          setTimeout(() => {
            navigate("/");
          }, 2000);
          setLoading(false);
        } else if (response.status === "error") {
          setOpen(true);
          setMessage(response.message);
          setSeverity(response.status);
          setLoading(false);
        }
      } else {
        setOpen(true);
        setMessage("Confirm password doesn’t match");
        setSeverity("error");
      }
    },
  });

  const isNotSpace = (event) => {
    if (!isNaN(event.keyCode) && event.keyCode === 32) {
      event.preventDefault();
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };
  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword((show) => !show);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Stack sx={{ backgroundColor: "#f7faff" }} className="bg">
      {loading && (
        <Loaders />
      )}
      <Grid2>
        <img
          src={require("../../assets/images/login_illustration.png")}
          className="img2"
          alt="img2"
          onDragStart={(e) => {
            e.preventDefault();
          }}
        />
        <Box
          component="form"
          onSubmit={formik.handleSubmit}
          className="box-element"
        >
          <Box sx={{ display: "grid", width: "100%", padding: "2.5rem" }}>
            <Box sx={{ paddingBottom: "6rem" }}>
              <img
                src={require("../../assets/logos/a2b-logo.svg").default}
                alt="a2bLogoImage"
                style={{ position: "absolute" }}
                width="82%"
                height="60px"
                onDragStart={(e) => {
                  e.preventDefault();
                }}
              />
            </Box>
            <Typography
              sx={{ fontWeight: "600", color: "#101828" }}
              variant="h5"
            >
              Set New Password
            </Typography>
            <Typography
              sx={{ marginTop: "0.5rem", color: "#475467" }}
              variant="body2"
            >
              At least 8 characters, with uppercase and lowercase letters.
            </Typography>
            <InputLabel
              sx={{ marginTop: "1.7rem", fontSize: "14px", color: "#344054", fontWeight: "600", zIndex: "2" }}
              htmlFor="outlined-adornment-password"
            >
              Set new password
            </InputLabel>
            <OutlinedInput
              sx={{ 
                height:  "38px", 
                marginTop: "2px",
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                }
              }}
              id="password"
              autoFocus
              placeholder="Enter Password"
              autoComplete="off"
              disabled={severity === "success"}
              type={showPassword ? "text" : "password"}
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={require("../../assets/logos/Password.svg").default}
                    alt="test"
                    width="16px"
                    height="18px"
                    onDragStart={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton onClick={handleClickShowPassword} edge="end">
                    {showPassword ? (
                      <img
                        src={require("../../assets/logos/eye_open.svg").default}
                        alt="test"
                        width="16px"
                        height="18px"
                        onDragStart={(e) => {
                          e.preventDefault();
                        }}
                      />
                    ) : (
                      <img
                        src={
                          require("../../assets/logos/eye_close.svg").default
                        }
                        alt="test"
                        width="16px"
                        height="18px"
                        onDragStart={(e) => {
                          e.preventDefault();
                        }}
                      />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              value={formik.values.password}
              inputProps={{ maxLength: 55 }}
              error={formik.touched.password && formik.errors.password}
              onChange={formik.handleChange}
              onKeyDown={(e) => isNotSpace(e)}
            />
            {formik.touched.password &&
              formik.errors.password &&
              (formik.errors.password === "Invalid Password" ? 
                  formik.values.password.length > 8 && formik.values.password.match(/(.*[A-Z].*)/g) && formik.values.password.match(/(.*[a-z].*)/g) ? 
                  (
                    <Typography variant="body2" style={{ color: "#F04438" }}>
                      {formik.errors.password}
                    </Typography>
                  )
                  : (
                  <Grid2 sx={{ marginTop: "1rem" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {formik.values.password.length < 8 ? (
                        <img
                          src={
                            require("../../assets/logos/password_error.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      ) : (
                        <img
                          src={
                            require("../../assets/logos/password_correct.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontSize: "14px",
                          color:
                            formik.values.password.length < 8 ? "red" : "green",
                        }}
                      >
                        At least 8 characters in length
                      </span>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {!formik.values.password.match(/(.*[A-Z].*)/g) ? (
                        <img
                          src={
                            require("../../assets/logos/password_error.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      ) : (
                        <img
                          src={
                            require("../../assets/logos/password_correct.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontSize: "14px",
                          color: !formik.values.password.match(/(.*[A-Z].*)/g)
                            ? "red"
                            : "green",
                        }}
                      >
                        At least 1 uppercase (A-Z)
                      </span>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {!formik.values.password.match(/(.*[a-z].*)/g) ? (
                        <img
                          src={
                            require("../../assets/logos/password_error.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      ) : (
                        <img
                          src={
                            require("../../assets/logos/password_correct.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontSize: "14px",
                          color: !formik.values.password.match(/(.*[a-z].*)/g)
                            ? "red"
                            : "green",
                        }}
                      >
                        At least 1 lowercase (a-z)
                      </span>
                    </Box>
                  </Grid2>
                )
               : (
                <Typography variant="body2" style={{ color: "#F04438" }}>
                  {formik.errors.password}
                </Typography>
              ))}
            <InputLabel
              sx={{ marginTop: "1rem", fontSize: "14px", color: "#344054", fontWeight: "600", zIndex: "2" }}
              htmlFor="outlined-adornment-confirm-password"
            >
              Confirm new password
            </InputLabel>
            <OutlinedInput
              id="confirmPassword"
              sx={{ 
                height:  "38px", 
                marginTop: "2px",
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                }
              }}
              placeholder="Enter Password"
              autoComplete="off"
              disabled={severity === "success"}
              type={showConfirmPassword ? "text" : "password"}
              inputProps={{ maxLength: 55 }}
              startAdornment={
                <InputAdornment position="start">
                  <img
                    src={require("../../assets/logos/Password.svg").default}
                    alt="test"
                    width="16px"
                    height="18px"
                    onDragStart={(e) => {
                      e.preventDefault();
                    }}
                  />
                </InputAdornment>
              }
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowConfirmPassword}
                    edge="end"
                  >
                    {showConfirmPassword ? (
                      <img
                        src={require("../../assets/logos/eye_open.svg").default}
                        alt="test"
                        width="16px"
                        height="18px"
                        onDragStart={(e) => {
                          e.preventDefault();
                        }}
                      />
                    ) : (
                      <img
                        src={
                          require("../../assets/logos/eye_close.svg").default
                        }
                        alt="test"
                        width="16px"
                        height="18px"
                        onDragStart={(e) => {
                          e.preventDefault();
                        }}
                      />
                    )}
                  </IconButton>
                </InputAdornment>
              }
              value={formik.values.confirmPassword}
              error={
                formik.touched.confirmPassword && formik.errors.confirmPassword
              }
              onChange={formik.handleChange}
              onKeyDown={(e) => isNotSpace(e)}
            />
            {formik.touched.confirmPassword &&
              formik.errors.confirmPassword &&
              (formik.errors.confirmPassword === "Invalid Password" ? 
                  formik.values.confirmPassword.length > 8 && formik.values.confirmPassword.match(/(.*[A-Z].*)/g) && formik.values.confirmPassword.match(/(.*[a-z].*)/g) ? 
                  (
                    <Typography variant="body2" style={{ color: "#F04438" }}>
                      {formik.errors.confirmPassword}
                    </Typography>
                  )
                  : (
                  <Grid2 sx={{ marginTop: "1rem" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {formik.values.confirmPassword.length < 8 ? (
                        <img
                          src={
                            require("../../assets/logos/password_error.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      ) : (
                        <img
                          src={
                            require("../../assets/logos/password_correct.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontSize: "14px",
                          color:
                            formik.values.confirmPassword.length < 8 ? "red" : "green",
                        }}
                      >
                        At least 8 characters in length
                      </span>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {!formik.values.confirmPassword.match(/(.*[A-Z].*)/g) ? (
                        <img
                          src={
                            require("../../assets/logos/password_error.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      ) : (
                        <img
                          src={
                            require("../../assets/logos/password_correct.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontSize: "14px",
                          color: !formik.values.confirmPassword.match(/(.*[A-Z].*)/g)
                            ? "red"
                            : "green",
                        }}
                      >
                        At least 1 uppercase (A-Z)
                      </span>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      {!formik.values.confirmPassword.match(/(.*[a-z].*)/g) ? (
                        <img
                          src={
                            require("../../assets/logos/password_error.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      ) : (
                        <img
                          src={
                            require("../../assets/logos/password_correct.svg")
                              .default
                          }
                          alt="test"
                          width="16px"
                          height="18px"
                          onDragStart={(e) => {
                            e.preventDefault();
                          }}
                        />
                      )}
                      <span
                        style={{
                          fontSize: "14px",
                          color: !formik.values.confirmPassword.match(/(.*[a-z].*)/g)
                            ? "red"
                            : "green",
                        }}
                      >
                        At least 1 lowercase (a-z)
                      </span>
                    </Box>
                  </Grid2>
                )
               : (
                <Typography variant="body2" style={{ color: "#F04438" }}>
                  {formik.errors.confirmPassword}
                </Typography>
              ))}
            <Button
              variant="contained"
              type="submit"
              style={{
                textTransform: "none",
                marginTop: "1.8rem",
                backgroundColor: "#0C68F4",
              }}
              onClick={formik.handleSubmit}
              disabled={formik.values.password !== formik.values.confirmPassword || severity === "success"}
            >
              Set New Password
            </Button>
            <Link
              sx={{
                marginTop: "1rem",
                maxWidth: "200px",
                margin: "1rem auto",
                color: "black",
                textDecorationColor: "black",
                fontSize: "14px",
                cursor: "pointer"
              }}
              underline="always"
              onClick={(e) => {
                if(severity !== "success") {
                  navigate("/Login");
                } else {
                  e.preventDefault();
                }
              }}
              onDragStart={(e) => {
                e.preventDefault();
              }}
            >
              Back to log in
            </Link>
          </Box>
        </Box>
      </Grid2>
      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Stack>
  );
}

export default SetNewPassword;
